import {
  getLocalStorage,
  setLocalStorage,
  localStorageDictionary,
  clearLocalStorage,
} from '../../../../../localStorage';

/**
 * Token Manager
 */
class TokenManager {
  /**
   * Get the token
   */
  public getToken(): string | null {
    const token = getLocalStorage(localStorageDictionary.CREDIT_BOOK_TOKEN);
    return token;
  }

  /**
   * Set the token to the local storage
   */
  public setToken(token: string) {
    setLocalStorage(localStorageDictionary.CREDIT_BOOK_TOKEN, token);
  }

  /**
   * Checks if the user is authenticated (has a valid token)
   */
  public isAuthenticated() {
    const token = this.getToken();
    return token !== null && token !== '';
  }

  /**
   * Clear the token from the local storage
   */
  public clear() {
    clearLocalStorage(localStorageDictionary.CREDIT_BOOK_TOKEN);
  }
}

export default TokenManager;
